import styled, {
  css,
  DefaultTheme,
  FlattenInterpolation,
  ThemeProps,
} from 'styled-components'

const spaceSize = {
  small: 8,
  middle: 16,
  large: 24,
}

type Size = 'small' | 'middle' | 'large' | number

export type SpaceProps = {
  align?: 'start' | 'end' | 'center' | 'baseline'
  className?: string
  direction?: 'horizontal' | 'vertical'
  size?: Size
}

/**
 * @deprecated Use `antd` Space instead.
 */
const Space = styled.div<SpaceProps>`
  display: inline-flex;
  align-items: ${(props): string | undefined => {
    const mergedAlign =
      props.align === undefined && props.direction === 'horizontal'
        ? 'center'
        : props.align
    switch (mergedAlign) {
      case 'start':
        return 'flex-start'
      case 'end':
        return 'flex-end'
      default:
        return mergedAlign
    }
  }};
  flex-direction: ${(props): string =>
    props.direction === 'vertical' ? 'column' : 'row'};

  > :not(:last-child) {
    ${(props): FlattenInterpolation<ThemeProps<DefaultTheme>> => {
      const propSize =
        typeof props.size === 'number'
          ? props.size
          : spaceSize[props.size ?? 'small']
      const marginRightSize = props.direction !== 'vertical' ? propSize : 0
      const marginBottomSize = props.direction === 'vertical' ? propSize : 0

      return css`
        margin-right: ${marginRightSize}px;
        margin-bottom: ${marginBottomSize}px;
      `
    }};
  }
`

export default Space
